import React from "react";
import { Truck, HeartPulse, Clock4 } from "lucide-react";
import { openWhatsapp } from "@/lib/cima";

export default function PromoBanner({ onOpenQuote }) {
  return (
    <section
      data-testid="promo-banner"
      aria-label="Promoción de recarga el mismo día - oxígeno medicinal"
      className="relative bg-[var(--cima-navy)] text-white overflow-hidden"
    >
      {/* Diagonal stripes accent */}
      <div className="absolute inset-0 stripe-accent opacity-20 mix-blend-overlay" />
      <div className="absolute -top-10 -right-10 w-44 h-44 stripe-accent opacity-30 rotate-12" />
      <div className="absolute -bottom-10 -left-10 w-44 h-44 stripe-accent opacity-30 -rotate-12" />

      {/* Sliding marquee on top */}
      <div className="bg-[var(--cima-red)] text-white py-2 overflow-hidden">
        <div className="promo-marquee flex gap-12 whitespace-nowrap font-mono-cima text-xs uppercase tracking-[0.3em]">
          {Array.from({ length: 6 }).map((_, i) => (
            <span key={i} className="flex items-center gap-3">
              <span className="w-1.5 h-1.5 bg-[var(--cima-orange)]" />
              Recargas de tanques portátiles el mismo día — en minutos
              <span className="w-1.5 h-1.5 bg-[var(--cima-orange)]" />
              Oxígeno medicinal sin esperas
            </span>
          ))}
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          {/* Left – label + features */}
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 bg-white text-[var(--cima-red)] px-3 py-1.5 mb-4">
              <HeartPulse className="w-4 h-4" />
              <span className="font-mono-cima text-[10px] uppercase tracking-[0.3em] font-semibold">
                Oxígeno Medicinal
              </span>
            </div>

            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
              Recargamos tu tanque portátil de oxígeno medicinal{" "}
              <span className="relative inline-block">
                <span className="relative z-10">en minutos.</span>
                <span className="absolute inset-x-0 bottom-1 h-2 bg-[var(--cima-orange)] -z-0" />
              </span>
            </h2>

            <p className="mt-4 text-white/90 max-w-xl leading-relaxed text-sm sm:text-base">
              Contamos con <strong>recargas de tanques portátiles el mismo día y en minutos</strong> — para que ningún paciente espere. Atención prioritaria y servicio a domicilio disponible en Zihuatanejo y zona conurbada.
            </p>

            <ul className="mt-6 grid sm:grid-cols-3 gap-4 sm:gap-3 max-w-2xl">
              <li className="flex items-center gap-2 text-sm">
                <Clock4 className="w-5 h-5 text-[var(--cima-orange-soft)] shrink-0" />
                <span>Recarga en minutos</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Truck className="w-5 h-5 text-[var(--cima-orange-soft)] shrink-0" />
                <span>Entrega a domicilio</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <HeartPulse className="w-5 h-5 text-[var(--cima-orange-soft)] shrink-0" />
                <span>Calidad medicinal certificada</span>
              </li>
            </ul>
          </div>

          {/* Right – CTAs */}
          <div className="lg:col-span-5 flex flex-col gap-3 lg:items-end">
            <button
              data-testid="promo-quote-button"
              onClick={() => onOpenQuote("Recarga de oxígeno medicinal — Mismo día")}
              className="w-full lg:w-auto bg-white text-[var(--cima-navy)] hover:bg-[var(--cima-orange)] hover:text-white transition-colors px-7 py-4 font-display font-bold uppercase tracking-wide text-sm flex items-center justify-center gap-3 border-2 border-white shadow-lg"
            >
              Solicitar recarga ahora
              <span className="w-2 h-2 bg-[var(--cima-red)] rounded-full" />
            </button>
            <button
              type="button"
              data-testid="promo-whatsapp-button"
              onClick={() =>
                openWhatsapp(
                  "Hola CIMA, quiero solicitar una RECARGA de oxígeno medicinal el mismo día."
                )
              }
              className="w-full lg:w-auto bg-transparent border-2 border-white text-white hover:bg-white hover:text-[var(--cima-navy)] transition-colors px-7 py-4 font-display font-bold uppercase tracking-wide text-sm flex items-center justify-center gap-3"
            >
              WhatsApp directo
            </button>
            <div className="text-[11px] font-mono-cima uppercase tracking-widest text-white/70 lg:text-right pt-1">
              * Aplica únicamente a recargas de oxígeno medicinal.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
